import { RefiOption } from '../../../RefiOption'
import { RefiDetail } from '../../../../../types/refinance'
import { filterMortgageRatesAndSort } from '../../../../../helpers/mortgageRates'

import styles from './RefiOptionReveal.module.scss'

export interface RefiOptionRevealProps {
  locked: boolean
  yearsInHome: number
  options: RefiDetail[]
  onClickOption: () => void
}

export const RefiOptionReveal = ({ locked, options, yearsInHome, onClickOption }) => {
  const filteredRefiOptions = filterMortgageRatesAndSort(options)

  return (
    <div className={styles.refiWrapper} data-qa='refi-section-container'>
      {filteredRefiOptions.map((option: RefiDetail) => (
        <RefiOption
          detail={option}
          locked={locked}
          yearsInHome={yearsInHome}
          key={`${option.type}_${option.years}`}
          onClick={() => onClickOption(option)}
        />
      ))}
    </div>
  )
}
